export const REQUEST_BOOKS = 'REQUEST_BOOKS';
export const SUCCESS_BOOKS = 'SUCCESS_BOOKS';
export const FAILURE_BOOKS = 'FAILURE_BOOKS';
export const CLEAR_BOOKS = 'CLEAR_BOOKS';
